import moment from "moment"

export const fromDateToString = (date: Date): string => {
    return moment(date).format("YYYY-MM-DD")
}
export const fromStringToDate = (date: string): Date => {
    return moment(date, "YYYY-MM-DD").toDate()
}